import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn';

import SVG from 'components/SVG';

import arrowSVG from './img/arrow-right.svg';

import './TableRow.scss';

const TableRow = ({ item, locale }) => {
  const b = block('table-row-cash');

  const operationType = useMemo(() => {
    switch(Number(item.operation)) {
      case 1: return locale.withdrawal;
      case 2: return locale.bonus;
      default: return locale.deposit;
    }
  }, [item, locale])

  return (
    <div className={b()}>
      <div className={b('td')}>
        <span className={b('td-value')}>{item.id}</span>
      </div>
      <div className={b('td')}>
        <span className={b('td-value')}>{item.createdAt}</span>
      </div>
      <div className={b('td')}>
        <span className={b('td-value')}>{operationType}</span>
      </div>
      <div className={b('td')}>{item.initiatorUser}</div>
      <div className={b('td')}>{item.fromUser}</div>
      <div className={b('td')}>{item.toUser}</div>
      <div className={b('td')}>
        <span className={b('td-value')}>{item.amount}</span>
      </div>
      <div className={b('td')}>
        <span className={b('td-value')}>{item.balanceFrom}</span>
        <SVG className={b('arrow')} svgProps={{ svg: arrowSVG }} />
        <span className={b('td-value')}>{item.balanceTo}</span>
      </div>
    </div>
  );
};

TableRow.propTypes = {
  item: PropTypes.object.isRequired,
};

export default TableRow;
